import {
  Row,
  Col,
  Card,
  Table,
  Tabs,
  Select,
  Tooltip,
  Button,
  Typography,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import moment from "moment";
import TabPane from "antd/lib/tabs/TabPane";
import { AppStateContext } from "../../../context/AppContext";
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from 'chart.js';
import { Bar, Line, Pie } from "react-chartjs-2";

// Register necessary elements for Chart.js
ChartJS.register(CategoryScale, ArcElement, ChartTooltip, ChartLegend);
const { Title } = Typography;


function View() {
  const heading = "User Challenges";
  const params = useParams();
  const { request } = useRequest();
  const { setPageHeading } = useContext(AppStateContext);
  const [completedChallenges, setCompletedChallenges] = useState([]);
  const [pairings, setPairings] = useState([]);
  const [userStats, setUserStats] = useState();
  const [storeData, setStoreData] = useState();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [selectedTab, setSelectedTab] = useState("completed");
  const [refresh, setRefresh] = useState(false);
  const [status, setStatus] = useState("current");
  const [type, setType] = useState("all");
  const navigate = useNavigate();

  const columns = [
    {
      title: "Challenge",
      dataIndex: "challenge",
      key: "challenge",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { challenge_id }) => {
        return challenge_id ? challenge_id?.title : "-";
      },
    },
    {
      title: "Challenger",
      dataIndex: "challenger",
      key: "challenger",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { created_by }) => {
        return created_by ? 
        <div className="posed-by_--emaill">
        <p>{created_by?.name}</p>
        <p>{created_by?.email}</p>
      </div>  : "-";
      },
    },
    {
      title: "Invitee",
      dataIndex: "invitee",
      key: "invitee",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { recieved_by }) => {
        return recieved_by ? 
        <div className="posed-by_--emaill">
        <p>{recieved_by?.name}</p>
        <p>{recieved_by?.email}</p>
      </div> : "-";
      },
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (_, { challenge_id }) => {
        return challenge_id ? challenge_id?.duration : "-";
      },
    },
    // {
    //   title: "completed",
    //   dataIndex: "is_complete",
    //   key: "is_complete",
    //   render: (_, { is_complete }) => {
    //     return is_complete ? "Yes" : "No";
    //   },
    // },
    {
      title: "Added On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  const columns2 = [
    {
      title: "Challenger",
      dataIndex: "challenger",
      key: "challenger",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { challenger }) => {
        return challenger ? 
        <div className="posed-by_--emaill">
        <p>{challenger?.name}</p>
        <p>{challenger?.email}</p>
      </div> : "-";
      },
    },
    {
      title: "Partner",
      dataIndex: "invitee",
      key: "invitee",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { receiver }) => {
        return receiver ? 
        <div className="posed-by_--emaill">
        <p>{receiver?.name}</p>
        <p>{receiver?.email}</p>
       </div> : "-";
      },
    },
    {
      title: "Partner 2",
      dataIndex: "invitee2",
      key: "invitee2",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { recieved_by_2 }) => {
        return recieved_by_2 ? 
        <div className="posed-by_--emaill">
        <p>{recieved_by_2?.name}</p>
        <p>{recieved_by_2?.email}</p>
       </div>: "-";
      },
    },
    {
      title: "Challenge Type",
      dataIndex: "is_friend",
      key: "is_friend",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { is_friend }) => {
        return !!is_friend ? "Friend" : "Community";
      },
    },
    {
      title: "Added On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"View Progress"} color={"purple"} key={"progress"}>
              <Button
                className="edit-cls btnStyle primary_btn"          
                onClick={() => {
                  navigate(`/customer/view/${record._id}/progress`, {
                    state: { data: record },
                  });
                }}
              >
            <i class="far fa-eye"></i>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const products = [
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      // sorter: (a, b) => a.product?.localeCompare(b.product),
      render: (_, { product_id }) => {
        return product_id ? product_id?.title : "-";
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      // sorter: (a, b) => a.category_id?.name?.localeCompare(b.challenge),
      render: (_, { category_id }) => {
        return category_id ? category_id?.name : "-";
      },
    },
    {
      title: "Invitee",
      dataIndex: "invitee",
      key: "invitee",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { recieved_by }) => {
        return recieved_by ? 
         <div className="posed-by_--emaill">
        <p>{recieved_by?.name}</p>
        <p>{recieved_by?.email}</p>
       </div> : "-";
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (_, { price }) => {
        return price ? price : "-";
      },
    },
    {
      title: "Ordered On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  const coupons = [
    {
      title: "Coupon Code",
      dataIndex: "coupon",
      key: "coupon",
      // sorter: (a, b) => a.coupon?.localeCompare(b.coupon),
      render: (_, { code }) => {
        return code ? code : "-";
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      // sorter: (a, b) => a.category_id?.name?.localeCompare(b.challenge),
      render: (_, { category_id }) => {
        return category_id ? category_id?.name : "-";
      },
    },
    {
      title: "Invitee",
      dataIndex: "invitee",
      key: "invitee",
      // sorter: (a, b) => a.challenge?.localeCompare(b.challenge),
      render: (_, { recieved_by }) => {
        return recieved_by ?  
        <div className="posed-by_--emaill">
        <p>{recieved_by?.name}</p>
        <p>{recieved_by?.email}</p>
       </div> : "-";
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (_, { price }) => {
        return price ? price : "-";
      },
    },
    {
      title: "Ordered On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
  ];

  const handleTabChange = (key) => {
    setSelectedTab(key);
  };

  const getChallenges = (id, status) => {
    setLoading(true);
    request({
      url: apiPath.getUserchlg + `/${id}` + `?type=${status}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data?.statusText == "true") {
          setCompletedChallenges(data?.data?.data ?? []);
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setLoading(false);
      },
    });
  };

  const getPairings = (id, type, status) => {
    setLoading3(true);
    request({
      url: apiPath.getPairings + `/${id}` + `?type=${type}&status=${status}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading3(false);
        if (data?.statusText == "true") {
          setPairings(data?.data?.data ?? []);
          console.log(data?.data, "data?.data");
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setLoading3(false);
      },
    });
  };

  const getUserStats = (id, status) => {
    setLoading(true);
    request({
      url: apiPath.getUserStats + `/${id}` + `?type=${status}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data?.status) {
          setUserStats(data?.data);
          console.log(data?.data, "data?.data");
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setLoading(false);
      },
    });
  };

  const getStoreData = (id) => {
    setLoading2(true);
    request({
      url: apiPath.getStoreData + `/${id}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading2(false);
        if (data?.status) {
          setStoreData(data?.data);
          console.log(data?.data, "data?.data");
        } else {
          ShowToast(data?.message, Severty.ERROR);
        }
      },
      onError: (err) => {
        setLoading2(false);
      },
    });
  };

  useEffect(() => {
    getUserStats(params.id);
    getStoreData(params.id);
  }, [params.id, refresh]);

  // useEffect(()=>{
  //   getChallenges(params.id, selectedTab);
  // },[params.id, refresh, selectedTab]);

  useEffect(() => {
    getPairings(params.id, type, status);
  }, [params.id, refresh, status, type]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const count = [
    {
      today: "Number of Challenges",
      title: `${userStats?.challenges || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "1",
    },
    {
      today: "Purchased Items",
      title: `${userStats?.products || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "2",
    },
    {
      today: "Feeds/Posts",
      title: `${userStats?.feeds || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "3",
    },
    {
      today: "Walk Away Challanges",
      title: `${userStats?.walkAways || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "4",
    },
    {
      today: "Completed Challanges",
      title: `${userStats?.completes || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "5",
    },
    {
      today: "Invite Sent",
      title: `${userStats?.sentInvites || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "6",
    },
    {
      today: "Invite Recieved",
      title: `${userStats?.receivedInvites || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "7",
    },
    {
      today: "Total Coupons",
      title: `${userStats?.coupons || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "8",
    },
    {
      today: "Expired Coupons",
      title: `${userStats?.expiredCoupons || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "9",
    },
    {
      today: "Total Skip Challenges",
      title: `${userStats?.purches_item || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "10",
    },
    {
      today: "Total Check-In Challenges",
      title: `${userStats?.checkIns || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "11",
    },
    {
      today: "Flagged Comments",
      title: `${userStats?.flagComments || 0}`,
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      key: "12",
    },
  ];

  
  const barData = {
    labels: ['30', '60', '90', '120', '150', '180', '210', '240', '270', '300' ],
    datasets: [
      {
        label: 'Enrollments',
        data: [2, 4, 14, 8, 10, 12, 4],
        backgroundColor: '#2fa68f',
      },
    ],
  };

  // Data for Profile Clicks Line Chart
  const lineData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    datasets: [
      {
        label: 'Profile Clicks',
        data: [50, 100, 150, 200, 250, 300, 200, 150, 100, 200, 250, 300],
        borderColor: '#2fa68f',
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const pieData = {
    labels: ['Walk Away Challanges', 'Current Challanges', 'Completed Challanges'], // The names for each slice
    datasets: [
      {
        label: 'Votes',
        data: [30, 50, 20], // Data values
        backgroundColor: ['#2fa68f', '#676C75', '#013557'], // Color for each slice
      },
    ],
  };
  const pieData01 = {
    labels: ['Skips', 'Checkin' ], // The names for each slice
    datasets: [
      {
        label: 'Votes',
        data: [30, 50,], // Data values
        backgroundColor: ['#2fa68f', '#676C75'], // Color for each slice
      },
    ],
  };

  // Options to customize the chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} sm={24} md={24}>
          <Row className="rowgap-vbox" gutter={[24, 16]}>
            {count.map((c, index) => {
              return (
                <Col
                  key={index}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={8}
                  xxl={6}
                  className="mb24"
                  style={{ paddingRight: "0px" }}
                >
                  <Card
                    bordered={false}
                    className="criclebox"
                    style={{ height: "100%" }}
                  >
                    <div className="number">
                      <Row align="middle" gutter={[24, 0]}>
                        <Col xs={18}>
                          <span>{c.today}</span>
                          <Title level={3}>{c.title}</Title>
                        </Col>
                        <Col xs={6}>
                          {" "}
                          <div className="icon-box">{c.icon}</div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>

      {/* <Card className="mt-3  ">
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <Tabs
                className="main_tabs main_tabs-main-new-s"
                onTabClick={handleTabChange}
                activeKey={selectedTab}
                tabBarStyle={{ color: "green" }}
              >
                <TabPane className="tab-btn" tab="Completed" key="completed">
                  <div className="table-responsive customPagination">
                    <Table
                      className="ant-border-space main-table"
                      loading={loading}
                      columns={columns}
                      dataSource={completedChallenges}
                      pagination={true}
                    />
                  </div>
                </TabPane>
                <TabPane className="tab-btn" tab="Current" key="current">
                  <div className="table-responsive customPagination">
                    <Table
                      className="ant-border-space main-table"
                      loading={loading}
                      columns={columns}
                      dataSource={completedChallenges}
                      pagination={true}
                    />
                  </div>
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        </div>
      </Card> */}
     <Row gutter={[24,24]} className="mt-4">
            <Col span={24} lg={12}>
                <Card  className="criclebox tablespace mb-24 mt-3"  title={"Days Status"}>
                    <div className="chart-cardbox"> 
                    <Bar data={barData} options={options} />
                    </div>
                </Card>
            </Col>
            <Col span={24} lg={12}  >
                <Card  className="criclebox tablespace mb-24 mt-3"  title={"Accountablity"}>
                    <div className="chart-cardbox"> 
                    <Bar data={barData} options={options} />
                    </div>
                </Card>
            </Col>
            <Col  span={24} lg={8} xl={6}>
                <Card className="criclebox tablespace mb-24 mt-3"  title={"Status"}>
                <div className="chart-cardbox"> 
                      <Pie className="dddd" data={pieData} options={options} />
                    </div>
                </Card>
            </Col>
            <Col  span={24} lg={8} xl={6}>
                <Card className="criclebox tablespace mb-24 mt-3"  title={"Check-In Challenges"}>
                <div className="chart-cardbox"> 
                      <Pie data={pieData01} options={options} />
                    </div>
                </Card>
            </Col>
          
          </Row>

      <Card className="mt-3  ">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Pairings</h3>
          <div className="role-wrap">
            <Select
              width="110px"
              style={{ marginInlineEnd: "10px" }}
              placeholder="Status"
              filterOption={false}
              defaultValue={"current"}
              options={[
                { value: "current", label: "Current" },
                { value: "completed", label: "Completed" },
                { value: "walkaway", label: "Walk Away" },
              ]}
              onChange={(value) => setStatus(value)}
            />
            <Select
              width="110px"
              placeholder="User Type"
              filterOption={false}
              defaultValue={"all"}
              options={[
                { value: "all", label: "All" },
                { value: "challenger", label: "Challenger" },
                { value: "receiver", label: "Receiver" },
              ]}
              onChange={(value) => setType(value)}
            />
          </div>
        </div>
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <div className="table-responsive customPagination">
                <Table
                  className="ant-border-space main-table"
                  loading={loading3}
                  columns={columns2}
                  dataSource={pairings}
                  pagination={true}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Card>

      <Card className="mt-3  ">
        <h3>Products Purchased</h3>
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <div className="table-responsive customPagination">
                <Table
                  className="ant-border-space main-table"
                  loading={loading2}
                  columns={products}
                  dataSource={[] || storeData?.products}
                  pagination={true}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Card>

      <Card className="mt-3  ">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>Coupons Earned</h3>
          {/* <div className="role-wrap">
            <Select
              width="110px"
              placeholder="Coupon Type"
              filterOption={false}
              options={[
                { value: "all", label: "All" },
                { value: "used", label: "Used" },
                { value: "expired", label: "Expired" },
              ]}
              onChange={(value) => getStoreData(params.id, value)}
            />
          </div> */}
        </div>
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <div className="table-responsive customPagination">
                <Table
                  className="ant-border-space main-table"
                  loading={loading2}
                  columns={coupons}
                  dataSource={[] || storeData?.coupons}
                  pagination={true}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Card>
    </>
  );
}

export default View;
